module.exports = __webpack_public_path__ + "static/img/7.38a77d9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/zh/7.png
// module id = lEvd
// module chunks = 0